module.exports = __webpack_public_path__ + "73963ec42b3f2a909683814d75072a83.svg";